<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>파트너 정보</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="blue"
            small
            fab
            @click="ShowSamplePage"
        >
            <v-icon 
            color= "white"
            >mdi-link-box</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <!-- 유저 아이디  -->
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">파트너사</v-card-title></span>       
            <span style="width:80%"><v-card-title style="font-weight:bold; color:grey">{{partner_name }} ({{partner_key }})</v-card-title></span>       
        </v-list-item>         
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">특이사항 메모</v-card-title></span>        
            <span style="width:400px">
            <v-text-field
                label="등록 시 특이사항을 입력해주세요 (선택) "
                v-model="partner_desc_text"
                value=""            
            ></v-text-field> 
            </span>
        </v-list-item>     
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">콜백 url</v-card-title></span>        
        <span style="width:80%">
        <v-text-field
            label="퀴즈 클리어 콜백url 을 입력해주세요 "
            v-model="partner_callback_url"
            value=""            
        ></v-text-field> 
        </span>
        </v-list-item>      
        <!-- <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">썸네일 이미지</v-card-title></span>        
        <span>            
            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+partner_info.thumb_url" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px;"> 
            
        </span>
        <span></span>
            <v-col cols="12" md="6">
            <v-file-input
            hide-details
            outlined
            @change="handleFileChange"
            >
                <template #label>
                    배너이미지 변경하기
                </template>
            </v-file-input>
        </v-col>
        </v-list-item>       -->
        <v-list-item style="display: flex; justify-content: center; align-items: center;">
            <!-- <v-btn width="120px"
                color="red"
                class='white--text'
                @click="OnSaveQuizBundle()">삭제하기</v-btn>
                <span style="width:30px"></span> -->
                <v-btn width="120px"
                color="blue"
                class='white--text'
                @click="OnSave_PartnerInfo()">수정하기</v-btn>
        </v-list-item>


    </v-list>
    </v-card>

    <div style="height:20px"></div>


    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>퀴즈 템플릿</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>

    <v-list>
        <v-data-table
            :footer-props="{'items-per-page-options': [-1]}"
            :headers="headers"
            :items="partner_templates"
            :loading="loadingData"
        >
            <template v-slot:item="{ item }">
            <tr>
                <!-- Index 표시 (1부터 시작) -->
                <td><v-col style="width: 80px;">{{ item.pid }} <span style="font-weight: 900;"></span></v-col></td>
                <!-- 이미지 및 파일 입력 -->
                <td>
                    <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb_url" alt="Image"  style="width: 60px; height: 60px; order: 2px solid black; border-radius: 10px;">                     
                </td>     
                  <!-- 답변 텍스트 입력 -->
                <td>
                    <span style="font-weight: 500; color:blue;">[ {{ item.group_title }} ]</span>
                </td>            
                <td>
                    <span style="font-weight: 500;">{{item.activation_start}} ~ {{item.activation_end}}</span>
                </td>
                <td>
                    <span :style="{ fontWeight: '900', color: item.activate == 'Y' ? 'green' : 'red' }">{{item.activate}}</span>
                    
                </td>
                <td>
                    <span :style="{ fontWeight: '900', color: item.activation_type == 'DAILY' ? 'green' : 'blue' }">{{item.activation_type}}</span>
                </td>
                 <td>
                    <span :style="{ fontWeight: '900'}">{{getQuizTypeLabel(item.quiz_type)}}</span>
                </td>
                <!-- 수정 버튼 -->
                <td>
                <v-btn
                    width="60px"
                    color="blue"
                    class="white--text"
                    @click="OnSaveEdit_Template_Item(item)"
                >
                    수정
                </v-btn>
                </td>
            </tr>
            </template>
        </v-data-table>
        </v-list>

    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="800"
    >
    <v-card>
        <v-card-title class="text-h5 mb-3">
            {{'템플릿 등록하기'}}
    </v-card-title>
    <v-card-text>           
    <v-row>
        <v-col cols="3"  class="text-center font-weight-bold text-h6">타이틀</v-col>
        <v-col><v-text-field 
                label="간단한 퀴즈 참여하기!"
                v-model="dialog_title_text" 
                outlined
                dense
                hide-details
            ></v-text-field></v-col>
    </v-row>
    <v-row>
        <v-col  cols="3"  class="text-center font-weight-bold text-h6">상세설명</v-col>
        <v-col>
        <v-text-field 
                label="이미지퀴즈의 정답을 모두 맞추면 성공!"
                v-model="dialog_desc_text" 
                outlined
                dense
                hide-details
            ></v-text-field>
        </v-col>
        </v-row>
   <v-row>
        <v-col  cols="3"  class="text-center font-weight-bold text-h6">광고키</v-col>
        <v-col>
        <v-text-field 
                label="공란시 애드매니저 기본광고키 적용"
                v-model="dialog_adm_api_key" 
                outlined
                dense
                hide-details
            ></v-text-field>
        </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="text-center font-weight-bold text-h6">
                배너 아이콘
            </v-col>
             <v-col cols="12" md="3">
            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+selected_editing_item.thumb_url" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px;"> 
            </v-col>
            <!-- 왼쪽: 이미지 업로드 입력 -->
            <v-col cols="12" md="6">
                <v-file-input
                label="배너이미지 (128*128 플랫폼별 다름)"
                accept="image/*"
                v-model="dialog_img_file"
                prepend-icon="mdi-image"
                outlined
                @change="handleFileChange"
                />
            </v-col>
        </v-row>
        <v-row>
           <v-col cols="3" class="text-center font-weight-bold text-h6">활성화 타입</v-col>
            <v-col md="4" class="text-h6 mb-3" style="height:50px;">
                <v-select
                    v-model="dialog_activation_type"
                    :items="['DAILY', 'NONE_LIMITED']"
                    label="활성화 타입 선택"
                    outlined
                    dense
                ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" class="text-center font-weight-bold text-h6">퀴즈 그룹</v-col>
            <v-col md="4" class="text-h6 mb-3" style="height:50px;">
                <v-select
                v-model="dialog_selected_group_pid"
                :items="quiz_group_list"
                item-text="title"       
                item-value="pid"        
                label="퀴즈 그룹 선택"
                outlined
                dense
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" class="text-center font-weight-bold text-h6">이미지 퀴즈 타입</v-col>
            <v-col md="4" class="text-h6 mb-3" style="height:50px;">
                <v-select
                v-model="dialog_selected_quiz_type"
                :items="quiz_type_list"
                item-text="title"       
                item-value="key"        
                label="퀴즈 타입 선택"
                outlined
                dense
                />
            </v-col>
        </v-row>

        <v-row v-if="dialog_activation_type=='DAILY'">
            <v-col cols="12"  class="font-weight-bold text-h6">활성화 시간 설정</v-col>
        </v-row>
        <v-row v-if="dialog_activation_type=='DAILY'">
            <v-col cols="12" md="6">
                <v-time-picker
                    v-model="dialog_start_time"
                    format="24hr"
                    label="시작 시간 선택"
                    full-width
                ></v-time-picker>
            </v-col>
            <v-col cols="12" md="6">
                <v-time-picker
                    v-model="dialog_end_time"
                    format="24hr"
                    label="종료 시간 선택"
                    full-width
                ></v-time-picker>
            </v-col>
        </v-row>
        <v-row style="margin-top:40px;">
        
            <v-col  md="1"></v-col>
            <v-col md="3" class="text-h6 mb-3" style="height:50px; font-weight: 900;">
                활성화 설정
            </v-col>
            <v-col md="2" class="text-h6 mb-3" style="height:50px;">
                <v-switch
                    v-model="dialog_activate"
                    color="indigo"
                    label=""
                    hide-details
                    inset
                    style="margin: auto;"
                />           
            </v-col>       
        </v-row>  
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreateTemplate"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { getQuizListGroupTypeOptions } from '../../config/quiz_types';
const { s3_upload ,   FileUpload_Async} = require("../../util/fileutil");

export default {
    name: 'UserList',

    data: () => ({
        partner_info:{},
        partner_name:'',
        partner_key:'',
        partner_desc_text:'',
        partner_callback_url:'',
        partner_imageFile : null, 


        partner_templates:[],
        
        dialog_desc_text:'', 
        dialog_adm_api_key:'', 
        dialog_title_text :'',
        dialog_img_file:null,
        dialog_start_time:'00:00',
        dialog_end_time:'23:59',
        dialog_quiz_count:5,
        dialog_activate: false,
        dialog_activation_type: 'DAILY',
        
        dialog : false,
        dialog_mode_is_edit : false,
        dialog_selected_group_pid:0,
        dialog_selected_quiz_type:'DEFAULT',
        

        loadingData:false,        
        create_date:'',
        headers: [            
            { text: 'PID', value: 'title' },           
            { text: '배너&아이콘', value: 'count' },           
            { text: '설정된 퀴즈 그룹', value: 'time' },
            { text: '노출 시간', value: 'time' },            
                
            { text: '활성화 상태', value: 'state' },
            { text: '활성화 타입', value: 'state' },
            { text: '퀴즈 타입', value: 'state' },
            { text: '편집하기', value: 'save' },
        ],
        quiz_list_all:[
        ],
        quiz_dic_for_pid:{

        },
        checkbox_state_container:{},

        selected_editing_item:{},
        quiz_group_list:[],
        quiz_type_list: getQuizListGroupTypeOptions().map(type => ({
            title: type.label,
            key: type.value
        }))

    }),

    created()
    {    
        this.loadPartnerInfo(this.$route.query.pid);    
        this.LoadGroupInfoList();
        //this.LoadQuizList(this.$route.query.pid);
    },


    methods:{
        ...mapActions([
            'GET_PARTNER_INFO',
            'CREATE_QUIZ_TEMPLATE',
            'GET_QUIZ_TEMPLATE_LIST',
            'EDIT_PARTNER_INFO',
            'EDIT_QUIZ_TEMPLATE',
            'GET_QUIZ_GROUP_INFO',
        ]),
        loadPartnerInfo(pid){   
            this.GET_PARTNER_INFO({pid}).then((body_data)=>{
                //console.log(JSON.stringify(body_data));
                this.partner_info = body_data.partner;
                this.partner_name = this.partner_info.partner_name;
                this.partner_key = this.partner_info.partner_key;
                this.partner_desc_text = this.partner_info.desc_text;
                this.partner_callback_url = this.partner_info.callback_url;
                //console.log(JSON.stringify(this.partner_info));
                //console.log(this.partner_name);
                this.partner_templates = body_data.templates;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            });           
        },
        LoadGroupInfoList(){   
            //this.loadingData = true;
            // let packageName = this.$store.state.selected_game_package;
            this.loadingData = true;
            this.quizbundle_list_all = [];
            this.GET_QUIZ_GROUP_INFO({}).then((body_data)=>{
                this.loadingData = false; 
                this.quiz_group_list = body_data.result.group;                
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },


        async CreateTemplate()
        {
            
            console.log(this.dialog_selected_group_pid);
            console.log(this.dialog_start_time);
            console.log(this.dialog_end_time);
            if (this.dialog_start_time >= this.dialog_end_time) {
                alert("시작 시간이 종료 시간보다 늦을 수 없습니다.");
                return;
            }
            if(!this.dialog_mode_is_edit && this.dialog_img_file == null)
            {
                alert("배너 아이콘 필수");
                return;
            }
            if(this.dialog_selected_group_pid == 0)
            {
                alert("선택된 그룹이 없습니다");
                return;
            }
            this.loadingData = true;
            this.dialog = false;    
            let thumb_url= this.selected_editing_item.thumb_url;
            
            if(this.dialog_img_file != null)
            {
                thumb_url = "snapquiz/quiz_img/pub/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(this.dialog_img_file.name);
                await FileUpload_Async(this.dialog_img_file,  thumb_url);
            }
            //partner_key, title, desc_text, thumb_url, activate, quiz_count, activation_start, activation_end
            let partner_key = this.partner_key;
            let title = this.dialog_title_text;
            let desc_text = this.dialog_desc_text;
            let adm_api_key = this.dialog_adm_api_key.replace(/\s+/g, "");
            console.log("JSJS : " + adm_api_key);
            const activate = this.dialog_activate?'Y':'N';
            const activation_type = this.dialog_activation_type;
            const activation_start = this.dialog_start_time;
            const activation_end = this.dialog_end_time;
            const ref_group_pid =  this.dialog_selected_group_pid;
            const quiz_type = this.dialog_selected_quiz_type;
            console.log(quiz_type);
            if(!this.dialog_mode_is_edit)
            {//Create 모드 
                this.CREATE_QUIZ_TEMPLATE({ partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key}).then((body_data)=>{
                    console.log("생성완료");
                    this.loadingData = false;
                    this.loadPartnerInfo(this.$route.query.pid);    
                });
            }
            else{
                const pid = this.selected_editing_item.pid;
                this.EDIT_QUIZ_TEMPLATE({pid, partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key}).then((body_data)=>{
                    console.log("수정완료");
                    this.loadingData = false;
                    this.loadPartnerInfo(this.$route.query.pid);    
                });
            }
        },
        handleFileChange(file)
        {
            this.partner_imageFile = file;
        },
        handleFileChange_Dialog(file)
        {
            this.dialog_img_file = file;
        },

        OnSaveEdit_Template_Item(item)
        {
            this.selected_editing_item = item; 
            
            this.dialog_selected_group_pid = item.ref_group_pid;
            
            console.log(JSON.stringify(item));
            console.log("JS:"+this.dialog_selected_group_pid);
            this.dialog_activation_type = item.activation_type;
            this.dialog_selected_quiz_type = item.quiz_type;
            this.dialog_mode_is_edit = true;
            this.dialog_title_text = item.title;
            this.dialog_desc_text = item.desc_text;
            this.dialog_adm_api_key = item.adm_api_key;
            this.dialog_start_time = item.activation_start;
            this.dialog_end_time = item.activation_end;
            this.dialog_quiz_count = item.quiz_count;
            this.dialog_activate = item.activate=='Y'?true:false;
            this.dialog_img_file = null;
            this.dialog = true;          
        },
        
        OnDeleteQuiz_Item(item)
        {
               // 기본 confirm 사용
            if (confirm("정말 삭제하시겠습니까?")) {
                    let pid = item.pid;
                    let bundle_pid = this.$route.query.pid;

                    // 삭제 로직 실행
                    this.DELETE_QUIZ({ bundle_pid, pid }).then((body_data) => {
                        this.LoadQuizList(this.$route.query.pid);
                        this.LoadQuizBundleInfo(this.$route.query.pid);    
                    }).catch((error) => {
                        console.error("삭제 실패:", error);
                    });
                } else {
                    // 취소를 누른 경우
                    console.log("삭제가 취소되었습니다.");
                }
        },

        OnClick_CreateItem()
        {
            this.dialog_selected_group_pid = 0;
            this.dialog_mode_is_edit = false;
            this.selected_editing_item = {}; 
            this.dialog_title_text = '간단한 퀴즈 참여하기';
            this.dialog_desc_text = '이미지퀴즈의 정답을 모두 맞추면 성공!';
            this.dialog_adm_api_key = '';            
            this.dialog_start_time = '00:00';
            this.dialog_end_time = '23:59';
            this.dialog_activation_type = 'DAILY';
            this.dialog_selected_quiz_type = 'DEFAULT';
            this.dialog_activate = true;
            this.dialog_img_file = null;
            this.dialog = true;
        },
        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        ShowSamplePage(){
            window.open('https://quiz.snapplay.io/pub_sample_quizlist?api_key=' + this.partner_key, '_blank');
            //window.open('http://localhost:4002/pub_sample_quizlist?api_key=' + this.partner_key, '_blank');
            //http://localhost:4002/pub_sample_quizlist?api_key=pub-jjdn2izakut9gkzn
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
        // 퀴즈 타입을 한글 라벨로 변환
        getQuizTypeLabel(quizType) {
            if (!quizType) return '미설정';
            const typeMap = {
                'DEFAULT': '일반(이미지) 퀴즈',
                'NORMAL': '일반(이미지) 퀴즈', // 기존 데이터 호환성
                'TILE': '블럭(이미지) 퀴즈',
                'HV': '가로세로 퀴즈',
                'CHOICE': '4지선답 퀴즈'
            };
            return typeMap[quizType] || quizType;
        },
        async OnSave_PartnerInfo() {
            this.loadingData = true;

            let thumb_url = this.partner_info.thumb_path;
            if(this.partner_imageFile != null)
            {
                thumb_url = "snapquiz/quiz_img/pub/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(this.partner_imageFile.name);
                FileUpload_Async(this.partner_imageFile, thumb_url);
                
            }
            const pid = this.$route.query.pid;
            const partner_name = this.partner_info.partner_name;
            const desc_text = this.partner_desc_text;
            const callback_url = this.partner_callback_url;
            
            this.EDIT_PARTNER_INFO({pid , partner_name,  desc_text , callback_url , thumb_url})
            .then((body_data)=>{
                this.loadingData = false;
                this.loadPartnerInfo(this.$route.query.pid);
            });
        }        
    },
    computed: {
        isLive(){
            return config.isLive;
        },     
    },
    components:{
    },
    watch :{

    }
};
</script>
<style scoped>
.small-time-picker {
  transform: scale(0.75); /* 전체 크기 비율 축소 */
  max-width: 240px;
  margin: 0 auto;
}
</style>